module.exports = "/_next/static/images/image@3x-28d69d9af317a3fef23ec3af3f53fe17.jpg";